import PropTypes from 'prop-types'

/**
 * @typedef {Object} TpmsTireProducer
 * @property {string} producerId
 * @property {string} name
 */
export const tpmsTireProducerPropType = PropTypes.shape({
    producerId: PropTypes.string,
    name: PropTypes.string
})
